import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20845 23946"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#fefefe;stroke-width:334.559}.fil0{fill:#000}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        id="XMLID_314_"
        d="m15354 11948 4659-5166-8959 5163 8952 5178z"
        className="fill stroke1"
        style={{
          strokeWidth: 334.559,
        }}
      />
      <path
        id="XMLID_493_"
        d="m10747 11393 8952-5159-6807 1441-2145-6616z"
        className="fill stroke1"
        style={{
          strokeWidth: 334.559,
        }}
      />
      <path
        id="XMLID_494_"
        d="M10116 11402V1054L7960 7671 1156 6220z"
        className="fill stroke1"
        style={{
          strokeWidth: 334.559,
        }}
      />
      <path
        id="XMLID_495_"
        d="M20698 6023z"
        className="fill stroke1"
        style={{
          strokeWidth: 334.559,
        }}
      />
      <path
        id="XMLID_496_"
        d="M147 17866z"
        className="fill stroke1"
        style={{
          strokeWidth: 334.559,
        }}
      />
      <path
        id="XMLID_497_"
        d="m831 17107 8960-5163L839 6766l4652 5174z"
        className="fill stroke1"
        style={{
          strokeWidth: 334.559,
        }}
      />
      <path
        id="XMLID_498_"
        d="M10413 23804z"
        className="fill stroke1"
        style={{
          strokeWidth: 334.559,
        }}
      />
      <path
        id="XMLID_500_"
        d="M10747 12497v10281l2138-6561 6804 1452z"
        className="fill stroke1"
        style={{
          strokeWidth: 334.559,
        }}
      />
      <path
        id="XMLID_501_"
        d="m10116 12485-8969 5169 6806-1441 2163 6673z"
        className="fill stroke1"
        style={{
          strokeWidth: 334.559,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
